import _ from 'lodash';
import cssUtil from 'gw-portals-util-js/CssUtil';

//import template from 'text!./cp-building-coverages-summary-directive.html';
//import styles from './BuildingCoveragesSummary-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        require: 'gwCpPremisesSummary',
        scope: {
            coverages: '=',
            filterSelected: '<',
            buildingId: '@?'
        },
        transclude: true,
        template: cssUtil.hashTemplate(template, styles),
        controller: ['$scope', '$state', function ($scope, $state) {

            $scope.$watchCollection('coverages', function (coverages) {
                if (!Array.isArray(coverages)) {
                    return;
                }

                $scope._coverages = coverages.filter(function (coverage) {
                    return !$scope.filterSelected || coverage.selected;
                }).map(function (coverage, idx) {
                    return _.assign({}, coverage, {
                        id: coverage.publicID || idx
                    });
                });
            });

            $scope.edit = function () {
                return $state.go('cpBuildingWizardEditCoverages', { buildingID: $scope.buildingId });
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/directives/cp-premises-summary-directive/cp-building-coverages-summary-directive/CPBuildingCoveragesSummaryDirective.js
// module id = 1831
// module chunks = 0